

































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isSessionDel } from '@/utils/session'
import LangSelect from '@/components/LangSelect/index.vue'
import { EventBus } from '@/utils/event'

@Component({
  name: 'Login',
  components: {
    LangSelect
  }
})
export default class extends Vue {
  private loginForm = {
    accountName: '',
    password: ''
  };

  created() {
    EventBus.$on('lang-changed', this.onLangChanged)
    isSessionDel('login')
  }

  destroyed() {
    EventBus.$off('lang-changed')
  }

  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!value) {
      callback(new Error(this.$t('error.notEmpty').toString()))
    } else {
      callback()
    }
  };

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 1) {
      callback(new Error(this.$t('error.notEmpty').toString()))
    } else {
      callback()
    }
  };

  private get loginRules() {
    return {
      accountName: [{ validator: this.validateUsername, trigger: 'change' }],
      password: [{ validator: this.validatePassword, trigger: 'change' }]
    }
  }

  private passwordType = 'password';
  private loading = false;
  private showDialog = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};

  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  mounted() {
    if (this.loginForm.accountName === '') {
      (this.$refs.accountName as Input).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as Input).focus()
    }
  }

  private showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus()
    })
  }

  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.loading = true
        try {
          await UserModule.Login(this.loginForm)
          this.$router
            .push({
              path: this.redirect || '/',
              query: this.otherQuery
            })
            .catch((error) => {
              // FIXME 路由跳转错误
              console.error(error)
            })
        } catch (error) {
          this.$message.error(this.$t('error.failedLogin').toString())
        } finally {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }

  /**
   * 监听切换语言事件
   */
  private onLangChanged(e: string) {
    (this.$refs.loginForm as ElForm).resetFields()
  }
}
